/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const me = /* GraphQL */ `
  query Me {
    me {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const teachers = /* GraphQL */ `
  query Teachers {
    teachers {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const students = /* GraphQL */ `
  query Students {
    students {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const studentsByTchId = /* GraphQL */ `
  query StudentsByTchId($id: ID) {
    studentsByTchId(id: $id) {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const getQuestionGroup = /* GraphQL */ `
  query GetQuestionGroup($id: ID!, $tsF: String!) {
    getQuestionGroup(id: $id, tsF: $tsF) {
      id
      qGId
      fTId
      tsS
      tsF
      aId
      wsT
      qs {
        a {
          mc
          sa
          mcma
          abox
        }
        qId
        r
        isMkd
        it {
          ttl
          vId
        }
      }
      createdAt
      updatedAt
    }
  }
`;
export const listQuestionGroups = /* GraphQL */ `
  query ListQuestionGroups(
    $id: ID
    $tsF: ModelStringKeyConditionInput
    $filter: ModelQuestionGroupFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listQuestionGroups(
      id: $id
      tsF: $tsF
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        qGId
        fTId
        tsS
        tsF
        aId
        wsT
        qs {
          qId
          r
          isMkd
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEntity = /* GraphQL */ `
  query GetEntity($id: ID!) {
    getEntity(id: $id) {
      id
      sId
      eData {
        sch {
          name
          isCurrentSubscriber
        }
        tch {
          firstName
          lastName
          email
          isAdmin
        }
        stu {
          firstName
          lastName
          email
          cohort
          group
          schId
        }
      }
      hstry {
        items {
          id
          qGId
          fTId
          tsS
          tsF
          aId
          wsT
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listEntitys = /* GraphQL */ `
  query ListEntitys(
    $id: ID
    $filter: ModelEntityFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEntitys(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sId
        hstry {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const bySId = /* GraphQL */ `
  query BySId(
    $sId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelEntityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    bySId(
      sId: $sId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sId
        hstry {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
